import React from 'react';
import styled from 'styled-components';
// import Lottie from 'react-lottie';

import { RegularText } from '../../components/common/Text';

import { fontSize } from '../../utils';
import { connect } from 'react-redux';
import VisitHeader from '../common/header';
import { Player } from '@lottiefiles/react-lottie-player';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  height: 100%;
  background: #ffffff;
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CaptionText = styled(RegularText)`
  margin-top: 12px;
  font-size: ${fontSize(0.75)};
`;

const StartScreen = ({ submitResponse, config, history, from }) => {
  return (
    <>
      <VisitHeader showMenu={false} showBack={true} from={from}></VisitHeader>
      <OuterContainer className="font-mont">
        <div className="flex flex-col p-32px overflow-y-scroll flex-1 text-center justify-start item-center">
          {config.hraLogo && config.showUpdatedHra ? (
            <div className="flex flex-row items-center justify-between m-x mr-12px">
              <img
                src={
                  'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png'
                }
                alt={'Visit Health'}
                style={{ width: '30%', maxWidth: '150px' }}
              />
              <img
                src={config.hraLogo}
                style={{ width: '45%', maxWidth: '250px' }}
                alt={'HRA Logo'}
              />
            </div>
          ) : (
            <div></div>
          )}
          <ColumnContainer>
            <Player
              src="https://assets6.lottiefiles.com/packages/lf20_Qkk8MTZ8T4.json"
              style={{ height: '193px', width: '193px' }}
              autoplay
              loop
            />
            <p className="text-title-xl font-bold text-custom714fff">
              Health Risk Assessment
            </p>
            <p className="text-title-s font-bold text-brochure mt-20">
              Assessment Criteria
            </p>
            <p
              className="text-title-m font-semibold text-custom714fff mt-10 fontFamily-mont pl-7 pr-7"
              style={{ letterSpacing: 0.5, lineHeight: '150%' }}
            >
              Basic Profile, Heart, Lipid, Water, Stress & Dental
            </p>
            <p
              className="text-body-l mt-24px font-medium text-brochure leading-6"
              style={{
                maxWidth: '500px',
              }}
              id="hra-disclaimer"
            >
              {config.showUpdatedHra && config.hraDisclaimer ? (
                <p
                  dangerouslySetInnerHTML={{ __html: config.hraDisclaimer }}
                ></p>
              ) : (
                'This assessment will only take 5 minutes. Please keep your medical reports within reach before answering the questions. We will share your responses with the organization, which will devise a plan to improve your health & well-being.'
              )}
            </p>
          </ColumnContainer>
          <ColumnContainer>
            <div
              className="bg-primary p-14px mt-20 text-custom714fff rounded-full self-center uppercase cursor-pointer w-75%"
              onClick={() => submitResponse('start')}
            >
              <p className="font-bold text-title-l text-textbox ">Start</p>
            </div>
            <CaptionText
              style={{
                color: '#302E6B',
                fontSize: '10px',
                fontWeight: 500,
                marginTop: '20px',
                width: '90%',
              }}
            >
              *The information that you provide will be treated with absolute
              confidentiality
            </CaptionText>
            {/* <div className="mt-16px flex flex-row items-center justify-center">
            <p className="text-txtlight font-semibold text-body-s text-center mr-8px">
              Powered by
            </p>
            <img
              src={
                'https://api.getvisitapp.com/apiv3/sponsor-images/sponsor-77.png'
              }
              alt={"Visit Health"}
              style={{ height: '16px' }}
            />
          </div> */}
          </ColumnContainer>
        </div>
      </OuterContainer>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    config: state.app.config,
  };
};

export default connect(mapStateToProps)(StartScreen);
